import React from "react";
import Image6 from "../../../images/DonateAToi.jpg";
import Image2 from "../../../images/KCCollegeEvent.jpg";
import Image5 from "../../../images/KohinoorBS.jpg";
import Image4 from "../../../images/KindnessCircles.jpg";
import PageLayout from "../../ui/PageLayout";
import PageHero from "../../ui/PageHero";
import CategoryCardGrid from "../../ui/CategoryCardGrid";
import FadeIn from "../../ui/FadeIn";

// const eventCards = [
  
// ];

const projectCards = [
  { to: "./KCCollege", image: Image2, title: "KC College Event" },
  { to: "./kohinoor", image: Image5, title: "Kohinoor Business School" },
  { to: "./kindnesscircles", image: Image4, title: "Kindness Circles" },
  { to: "./donateatoi", image: Image6, title: "Donate-A-Toi" },
];

const Education = () => (
  <PageLayout>
    <PageHero title="KU for Education" light />
    {/* <section className="ku-section bg-ku-cream">
      <div className="ku-container">
        <CategoryCardGrid cards={eventCards} columns={2} bare />
      </div>
    </section> */}
    <section className="ku-section bg-white">
      <div className="ku-container">
        <FadeIn>
          <h3 className="ku-heading-md text-ku-royal mb-3">Projects</h3>
          <div className="w-16 h-1 bg-ku-gold rounded-full mb-8" />
        </FadeIn>
        <CategoryCardGrid cards={projectCards} columns={2} bare />
      </div>
    </section>
  </PageLayout>
);

export default Education;
